var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaunchpad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.592,
    viewBox: "0 0 24 24.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sprout",
    transform: "translate(-54.141 -28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 24,
    height: 24,
    transform: "translate(54.141 28)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(-3 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M102.055,11.73v-1.8a6.425,6.425,0,0,0,4.059-1.614,6.937,6.937,0,0,0,1.627-4.8.708.708,0,0,0-.668-.668,6.936,6.936,0,0,0-4.8,1.627,4.575,4.575,0,0,0-.5.6,6.641,6.641,0,0,0-1.66-3.121C97.992-.169,94.509,0,94.362.006a.708.708,0,0,0-.668.668c-.008.147-.175,3.631,1.942,5.748a7.782,7.782,0,0,0,5,1.936V11.73a6.3,6.3,0,0,1,1.416,0Z",
    transform: "translate(-32.207 22)",
    fill: "#fac668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M79.644,335.078a4.606,4.606,0,0,0-1.445.232,6.46,6.46,0,0,0-11.884,0,4.614,4.614,0,0,0-6.058,4.381v1.847a.92.92,0,0,0,.92.92H83.337a.92.92,0,0,0,.92-.92v-1.847a4.618,4.618,0,0,0-4.613-4.613Z",
    transform: "translate(-3.116 -296.865)",
    fill: "#fac668"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchpad);
export default __webpack_public_path__ + "static/media/launchpad.244d19b5.svg";
export { ForwardRef as ReactComponent };